import React from "react";
import "./CancellationPolicy.css";

const CancellationPolicy = () => {
  return (
    <section className="cancellation-policy">
      <div className="cancellation-container">
        <h2>Cancellation Policy</h2>
        <p className="intro">
          We understand that plans can change. Please review our policy below, designed in accordance with standard U.S. travel and consumer protection guidelines.
        </p>
        <div className="policy-content">
          <h3>General Terms</h3>
          <ul>
            <li>
              You may cancel your booking without penalty within 24 hours of purchase, as required by U.S. law.
            </li>
            <li>
              Free cancellation is allowed up to 48 hours before the scheduled departure or check-in date.
            </li>
            <li>
              Cancellations within 48 hours of departure may incur a 30% cancellation fee.
            </li>
            <li>
              No-shows or cancellations on the day of travel are non-refundable.
            </li>
          </ul>
          <h3>Refund Process</h3>
          <p>
            Refunds for eligible cancellations will be processed to your original payment method within 7–10 business days. Please note banks and card issuers may take additional time to release the funds.
          </p>
          <h3>Special Conditions</h3>
          <ul>
            <li>
              Peak-season, holiday, and promotional bookings may carry stricter cancellation policies, which will be clearly displayed at the time of booking.
            </li>
            <li>
              Group bookings of 10 or more travelers must be canceled at least 7 days before the scheduled start date for a full refund.
            </li>
            <li>
              In the event of unforeseen circumstances (like severe weather or government advisories), exceptions may be made according to local and federal regulations.
            </li>
          </ul>
          <h3>Travel Insurance</h3>
          <p>
            We highly recommend purchasing travel insurance to cover unexpected circumstances such as illness, natural disasters, or other emergencies.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CancellationPolicy;
